<template>
  <b-table v-bind="tableAttributes" :items="items" :fields="fields">

    <template #cell(id)="data">
      <span class="text-wrap">{{ data.item.id }}</span>
    </template>


    <template #cell(user)="data">
      <span class="text-wrap">{{ data.item.user.name }} {{ data.item.user.last_name }}</span>
    </template>

    <template #cell(offer_amount)="data">
      <span class="text-wrap">{{ formatNumber(data.item.offer_amount) }}</span>
    </template>

    <template #cell(paying_amount)="data">
      <span class="text-wrap">{{ formatNumber(data.item.paying_amount) }}</span>
    </template>

    <template #cell(total_amount)="data">
      <span class="text-wrap">{{ formatNumber(data.item.total_amount) }}</span>
    </template>

    <template #cell(payment_status)="data">
      <span class="text-wrap">{{ data.item.payment_status.status_name }}</span>
    </template>

    <template #cell(status)="data">
      <span>{{ data.item.status.status_name }}</span>
    </template>

    <template #cell(shopping_cart_created_at)="data">
      <span v-html="addEnterBetweenDateAndTime(data.item.created_at)" dir="ltr"></span>
    </template>


    <template #cell(action)="data">


      <div>
        <span class="h5" v-b-tooltip.hover title="جزییات سفارش">
          <router-link target="_blank"
                       :to="{ name: 'Factor', params: { orderId: data.item.id } }"
          >
            <b-icon icon="cart-fill" class="mx-2 text-dark"></b-icon>
          </router-link>
        </span>

        <span v-b-tooltip.hover title="وضعیت سفارش" v-b-modal="`order_status_${data.item.id}`" v-if="isUserHaveAccess"
              class="mx-2  h5"><b-icon-card-checklist
        /></span>


        <b-modal :id="`order_status_${data.item.id}`" hide-footer>
          <div class="text-right">
            <p>تعیین وضعیت سفارش {{ data.item.id }} متعلق به کاربر {{ data.item.user.name }} {{
                data.item.user.last_name
              }}</p>
            <b-container class="mx-auto text-center">
              <b-row class="text-center" align-h="center">
                <b-btn class="mx-2 px-3" pill variant="success" @click="loanRequest(data.item,1)">تایید</b-btn>
                <b-btn class="mx-2 px-3" pill variant="danger" @click="loanRequest(data.item,0)">رد</b-btn>
              </b-row>
            </b-container>


          </div>
        </b-modal>


        <div class="d-inline-block" v-if="data.item.status.status_id >= 2 && data.item.status.status_id != 6">
          <span class="h5" v-b-tooltip.hover title="قسط ها">
          <router-link target="_blank"
                       :to="{ name: 'LoanItems', params: {user: data.item.user.id, order: data.item.id } }"
          >
            <b-icon icon="calendar-fill" class="mx-2 text-dark"></b-icon>
          </router-link>
        </span>
          <span v-if="isUserHaveAccess" class="h5" v-b-modal="`general-info-${data.item.id}`"
                v-b-tooltip.hover title="ثبت کد مرسوله">
        <b-icon :variant="`${(data.item.shipment_code === null || data.item.shipment_code=='' ) ? '':'success'}`"
                icon="pen" class="mx-2 "></b-icon>
        </span>
          <b-modal :id="`general-info-${data.item.id}`" hide-footer>
            <div class="text-right">

              <form @submit.prevent="updateOrderGeneralInfo(data.item)">


                <b-form-group
                    id="input-group-1"
                    label="کد مرسوله"
                    label-for="input-1"
                    class="mb-4 mt-3">
                  <b-form-input
                      v-model="data.item.shipment_code"
                      type="text"
                      placeholder="کد مرسوله"
                      class=" text-left"
                  ></b-form-input>
                </b-form-group>

                <b-button class="btn w-100 my-2 btn-success" pill type="submit">ثبت</b-button>

              </form>


            </div>
          </b-modal>
        </div>


      </div>

    </template>


  </b-table>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {order_status} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart';
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import FormGroup from "../../validator/FormGroup";
import {required} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue';
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "tableItemOfOrders",
  components: {FormGroup, FormErrorsManager,},
  props: ["items", "restoreState"],
  data() {
    return {
      tableAttributes,
      fields: [
        {key: "id", label: "شناسه سفارش"},
        {key: "user", label: "کاربر"},
        {key: "total_amount", label: "قیمت کل"},
        {key: "offer_amount", label: "تخفیف"},
        {key: "paying_amount", label: "قابل پرداختی"},
        {key: "payment_status", label: "وضعیت پرداخت"},
        {key: "status", label: "وضعیت سفارش"},
        {key: "shopping_cart_created_at", label: "تاریخ ثبت سفارش"},
        {key: "action", label: ""},
      ],
      order_status,
      order_id: '',
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: 'User/isAdmin',
      isStore: 'User/isUserStore'
    }),
    isUserHaveAccess() {
      return this.isAdmin || this.isStore
    },
    getOrderStatus() {
      return this.order_status;
    }
  },
  methods: {
    ...mapActions({
      changeOrderStatus: 'ShoppingCart/changeOrderStatus',
    }),
    setDataForChangeOrderStatus(data) {
      const order_id = data.item.id;
      const status = data.item.status.status_id;
      this.changeOrderStatus({order_id, status});

    },
    formatNumber,
    dateConverter,
    addEnterBetweenDateAndTime(date) {
      date = this.dateConverter(date, '/', true);
      return date.replace(' ', '<br>')
    },
    updateOrderGeneralInfo(data) {
      const form = {
        order_id: data.id,
        shipment_code: data.shipment_code,
      }
      this.$store.dispatch('ShoppingCart/updateOrderGeneralInfo', form)
    },
    async loanRequest(item, status) {
      const form = {
        status: status,
        order_id: item.id,
      }
      await this.$store.dispatch('ShoppingCart/changeOrderStatus', form)
      // refresh table
      let page = this.$route.query.page
      if (page == undefined) {
        page = 1
      }
      await this.$store.dispatch('Loan/getLoans', page)

    }
  },

};
</script>

<style scoped>


</style>